/** @format */

import { Environment, SmsNotification } from '@shared/data-access/interfaces';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, map, retry } from 'rxjs/operators';

import { DCSG_CONSTANTS } from '@shared/data-access/constants';
import { Injectable } from '@angular/core';
import { MediaType } from '@shared/data-access/enums';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SmsNotificationDao {
  constructor(
    private readonly http: HttpClient,
    private readonly environment: Environment,
  ) {}

  public static handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }

  public getSmsOptInNotificationValue(phoneNumber: string) {
    if (phoneNumber) {
      const url = `${this.environment.api.smsOptIn.basePath}/${phoneNumber}/dsg_transactional`;

      return this.http.get<SmsNotification>(url, { headers: this.getHeaders() }).pipe(
        map((data: SmsNotification) => {
          return data;
        }),
        retry(1),
        catchError(SmsNotificationDao.handleError),
      );
    }
  }

  public setSmsOptInNotificationValue(phoneNumber: string) {
    if (phoneNumber) {
      const input = {
        phoneNumber: phoneNumber,
        list: 'dsg_transactional',
        signupSource: 'checkout',
      };

      const url = `${this.environment.api.smsOptIn.basePath}`;

      return this.http.post<SmsNotification>(url, input, { headers: this.getHeaders() }).pipe(
        map((data: SmsNotification) => {
          return data;
        }),
        retry(1),
        catchError(SmsNotificationDao.handleError),
      );
    }
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      Accept: MediaType.APPLICATION_JSON,
      'Content-Type': MediaType.APPLICATION_JSON,
      'Access-Control-Allow-Origin': '*',
      'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
      Pragma: 'no-cache',
      'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.short}`,
      'Ocp-Apim-Subscription-Key': `${this.environment.apiTokens.smsOptIn.apimSecret}`,
      'Access-Control-Allow-Headers':
        'Origin, X-Requested-With, Content-Type, Accept,Content-Type, Ocp-Apim-Subscription-Key, X-TIMEOUT',
    });
  }
}
